export default "__VITE_ASSET__Cx8an2Ik__"